import React from 'react';

export const STEP_USERNAME = 'username';
export const STEP_PASSWORD = 'password';
export const STEP_TOTP_CODE = 'totp-code';
export const STEP_TOTP_CONFIG = 'totp-config';
export const STEP_TOTP_INVALID = 'totp-invalid';
export const STEP_TOTP_SN_WARNING = 'totp-sn-warning';

export type AuthData = {
  // Data from Server
  totpSecret?: string;

  // Data from User
  password?: string;
  totp?: string;
  username?: string;
  regKey?: string;

  // Errors

  errorAuthenticating?: string;
  errorFetchingLoginConfig?: string;
  loginError?: string;

  // Form State
  currentStep: string;
  isAuthenticating: boolean;
  isDeauthenticating: boolean;
  isFetchingLoginConfig: boolean;
  isFetchingRedirect: boolean;
  isFetchingTotpSecret: boolean;
  isSSO: boolean;
  isUsingTotp: boolean;
  isTotpInvalid: boolean;
  isValidatingTotp: boolean;
  serverType?: {
    master: boolean;
    storage: boolean;
  };
  clusterType?: {
    consumer: boolean;
    business: boolean;
    cpc: boolean;
    enterprise: boolean;
  };
};

export const DEFAULT_AUTH_DATA: AuthData = {
  currentStep: STEP_USERNAME,
  isAuthenticating: false,
  isDeauthenticating: false,
  isFetchingLoginConfig: false,
  isFetchingRedirect: false,
  isFetchingTotpSecret: false,
  isSSO: false,
  isUsingTotp: false,
  isTotpInvalid: false,
  isValidatingTotp: false,
};

type AuthDataContextValue = {
  authData: AuthData;
  setAuthData: React.Dispatch<React.SetStateAction<AuthData>>;
};

export const AuthDataContext = React.createContext<AuthDataContextValue>({
  authData: DEFAULT_AUTH_DATA,
  setAuthData: () => null,
});
